const MAX_NAME_LENGTH = 249;

export const validateNameLength = ({
  name = '',
  maxLength = MAX_NAME_LENGTH,
}: {
  name?: string;
  maxLength?: number;
}): { isValid: boolean; errorMessage?: string } => {
  const errorMessage = `Name shouldn't exceed ${maxLength} characters`;

  if (name.length > maxLength) {
    return { isValid: false, errorMessage };
  }
  return { isValid: true };
};
